import * as React from 'react';

import {ReadOnlyText} from '../read-only-text';

import styles from './phone-message-preview.module.css';

type Props = {
    message: string;
    optOutText?: string;
};

export function PhoneMessagePreview(props: Props) {
    const containerRef = React.useRef(null);
    const [messageSize, setMessageSize] = React.useState('normal');

    React.useEffect(() => {
        const updateSize = () => {
            if (containerRef.current) {
                // @ts-expect-error
                const width = containerRef.current.offsetWidth;
                // @ts-expect-error
                const height = containerRef.current.offsetHeight;

                // Adjust these thresholds as needed
                if (width < 175 || height < 325) {
                    setMessageSize('mini');
                } else if (width < 250 || height < 400) {
                    setMessageSize('small');
                } else {
                    setMessageSize('normal');
                }
            }
        };

        updateSize();
        window.addEventListener('resize', updateSize);

        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return (
        <div ref={containerRef} className={styles['phone-container']}>
            <div className={styles['screen-container']}>
                <div className={styles['message-container']}>
                    <ReadOnlyText
                        message={props.message}
                        optOutText={props.optOutText}
                        // @ts-expect-error
                        size={messageSize}
                    />
                </div>
            </div>
        </div>
    );
}
